import React, { useMemo } from 'react';
import NavigationStepper, {
	NavigationStepperProps,
} from '../NavigationStepper';
import TabNavigationStepperItems from './TabNavigationStepperItems';

interface Props extends NavigationStepperProps {
	fallbackStep: string;
}

const TabNavigationStepper: React.FC<Props> = props => {
	const initialStepPath = useMemo(() => {
		if (!props.steps.find(step => step.key === props.initialStepPath)) {
			return props.fallbackStep;
		}
		return props.initialStepPath;
	}, [props.initialStepPath]);

	return (
		<NavigationStepper
			{...props}
			initialStepPath={initialStepPath}
			renderItems={({ items, activeKey, onChange }) => (
				<TabNavigationStepperItems
					items={items}
					activeKey={activeKey}
					onChange={onChange}
				/>
			)}
		/>
	);
};

export default TabNavigationStepper;
